<script setup lang="ts">
import { useFormAlertsStore } from "@/stores/alerts";
// @ts-ignore
import i18n from '@/localization/i18n';
import constants from "@/utils/constants";

// Local variables
const t = i18n.global.t;

// Stores
const alerts = useFormAlertsStore();
</script>

<template>
  <div class="col-12">
    <div v-for="alert in alerts.getAlerts">
      <div
        v-if="alert.code === constants.LOGIN_FAILED_MESSAGE"
        class="alert p-2 alert-danger"
        role="alert"
      >
        {{ t("w_msg_loginFailed") }}
      </div>
      <div
        v-if="alert.code === constants.LOGIN_ATTEMPT_LIMIT_MESSAGE"
        class="alert p-2 alert-danger"
        role="alert"
      >
        {{ t("w_msg_attemptLimit") }}
      </div>
      <div
        v-if="alert.code === 'passwordsNotMatching'"
        class="alert p-2 alert-danger"
        role="alert"
      >
        {{ t("w_msg_passwordsDifferent") }}
      </div>
      <div
        v-if="alert.code === 'wrongOldPassword'"
        class="alert p-2 alert-danger"
        role="alert"
      >
        {{ t("w_msg_currentPasswordWrong") }}
      </div>
      <div
        v-if="alert.code === 'wrongPasswordEmailVerification'"
        class="alert p-2 alert-danger"
        role="alert"
      >
        {{ t("w_msg_passwordWrong") }}
      </div>
      <div
        v-if="alert.code === 'invalidCaptcha'"
        class="alert p-2 alert-danger"
        role="alert"
      >
        {{ t("w_msg_captchaCodeWrong") }}
      </div>
      <div
        v-if="alert.code === 'emailVerificationCodeWrong'"
        class="alert p-2 alert-danger"
        role="alert"
      >
        {{ t("w_msg_emailVerificationCodeWrong") }}
      </div>
      <div
        v-if="alert.code === 'signupEmailExists'"
        class="alert p-2 alert-danger"
        role="alert"
      >
        {{ t("w_msg_email_already_in_use") }}
      </div>
      <div
        v-if="alert.code === 'signupUsernameExists'"
        class="alert p-2 alert-danger"
        role="alert"
      >
        {{ t("w_msg_usernameTaken") }}
      </div>
      <div
        v-if="alert.code === 'signupNumberExists'"
        class="alert p-2 alert-danger"
        role="alert"
      >
        {{ t("w_msg_phoneInvalid") }}
      </div>
      <div
        v-if="alert.code === 'unAuthorized'"
        class="alert p-2 alert-danger"
        role="alert"
      >
        {{ t("m_msg_an_error_occurred") }}
      </div>
      <div
        v-if="alert.code === 'notFoundOrInvalidEmail'"
        class="alert p-2 alert-danger"
        role="alert"
      >
        {{ t("w_msg_not_found_or_invalid_email") }}
      </div>
    </div>
  </div>
</template>
